"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyImage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _color = require("../../helpers/color");

var _Box = require("../Box");

var _CleanTag = require("../CleanTag");

var _Image = require("./Image.shared");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var imagePropsToOmit = _CleanTag.omitProps.filter(function (prop) {
  return prop !== "width" && prop !== "height";
});

var InnerLazyImage = (0, _styledComponents.default)(_CleanTag.CleanTag.as(_reactLazyLoadImageComponent.LazyLoadImage)).withConfig({
  displayName: "LazyImage__InnerLazyImage",
  componentId: "sc-1fxlbs3-0"
})(["width:100%;height:100%;", " transition:opacity 0.25s;"], _styledSystem.borderRadius);
InnerLazyImage.displayName = "InnerLazyImage";
/**
 * The animation that's used for the background of an image while it's loading
 * in.
 */

var pulse = (0, _styledComponents.keyframes)(["0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}"], (0, _color.color)("black10"), (0, _color.color)("black5"), (0, _color.color)("black10")); // TODO: Move animation out to a shared place

var pulseAnimation = function pulseAnimation() {
  return (0, _styledComponents.css)(["", " 2s ease-in-out infinite;"], pulse);
};

var Placeholder = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "LazyImage__Placeholder",
  componentId: "sc-1fxlbs3-1"
})(["background-color:", ";animation:", ";", ""], (0, _color.color)("black10"), pulseAnimation, _styledSystem.borderRadius);

/** LazyImage */
var LazyImage = function LazyImage(_ref) {
  var _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? false : _ref$preload,
      _ref$imageComponent = _ref.imageComponent,
      ImageComponent = _ref$imageComponent === void 0 ? _Image.BaseImage : _ref$imageComponent,
      props = _objectWithoutProperties(_ref, ["preload", "imageComponent"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isImageLoaded = _useState2[0],
      setImageLoaded = _useState2[1];

  var src = props.src,
      title = props.title,
      alt = props.alt,
      ariaLabel = props["aria-label"],
      width = props.width,
      height = props.height,
      borderRadius = props.borderRadius,
      style = props.style,
      containerProps = _objectWithoutProperties(props, ["src", "title", "alt", "aria-label", "width", "height", "borderRadius", "style"]);

  return preload ? _react.default.createElement(ImageComponent, props) : _react.default.createElement(Placeholder, _extends({
    width: width,
    height: height,
    borderRadius: borderRadius
  }, containerProps), _react.default.createElement(InnerLazyImage, {
    omitFromProps: imagePropsToOmit,
    src: src,
    title: title,
    alt: alt,
    "aria-label": ariaLabel,
    borderRadius: borderRadius,
    width: "100%",
    height: "100%",
    style: _objectSpread({}, style, {
      opacity: isImageLoaded ? "1" : "0"
    }),
    onLoad: function onLoad() {
      return setImageLoaded(true);
    }
  }), _react.default.createElement("noscript", null, _react.default.createElement(ImageComponent, props)));
};

exports.LazyImage = LazyImage;
//# sourceMappingURL=LazyImage.js.map